/**
 * 서명 GET(attachment) URL 을 navigate 로 연다 (SUPER-7 D3).
 *
 * fetch+blob 으로 받지 않는 이유 — 버킷 GET 에 CORS 협상이 다시 필요해진다.
 * Content-Disposition: attachment 라 브라우저는 페이지를 떠나지 않고 저장만 시작한다.
 *
 * 별도 모듈인 이유 — jsdom 은 실제 내비게이션을 구현하지 않아, 테스트가 이 심(seam)을
 * jest.mock 으로 갈아끼운다.
 */
export function startFileDownload(url: string): void {
  window.location.assign(url);
}
